"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTypeAgregator = void 0;
class PaymentTypeAgregator {
    constructor() { }
}
exports.PaymentTypeAgregator = PaymentTypeAgregator;
//# sourceMappingURL=payment.type.agregator.nst.js.map